module.exports = __webpack_public_path__ + "static/tablet-edec5e8c6a986917caee1aff7a3ec94e.svg";